import { useEffect } from "react";
import DatePicker from "react-datepicker";
import "./styles.scss";

import "react-datepicker/dist/react-datepicker.css";

const DatePickerComponent = ({
  onChange,
  title,
  placeholder,
  error,
  name,
  value,
  id,
  minDate,
  maxDate,
  minTime,
  showMonthYearPicker,
  dateFormat,
  maxTime,
  prefix,
  ...props
}) => {
  let datepicker = document.getElementById(id);
  useEffect(() => {
    if (datepicker) {
      // datepicker.style.height = "28px";
      datepicker.style.border = "1px solid #0e6fba";
      datepicker.style.borderRadius = "6px";
      datepicker.style.paddingLeft = "6px";
    }
  }, [datepicker]);
  return (
    <div className="datepicker-container">
      {title && <div className="datepicker-title">{title}</div>}
      <div className="datepicker">
        {prefix && (
          <img className="prefix-icon" src={`/icons/${prefix}`} alt="" />
        )}
        <DatePicker
          id={id}
          name={name}
          className={error ? "error-text" : ""}
          selected={value}
          dateFormat={ dateFormat || "yyyy/MM/dd" }
          onChange={onChange}
          showMonthYearPicker={showMonthYearPicker}
          placeholderText={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          minTime={minTime}
          maxTime={maxTime}
          {...props}
        />
      </div>
      {error ? <span className="datepicker-error-message">{error}</span> : null}
    </div>
  );
};
export default DatePickerComponent;
